import { Star } from 'lucide-react';

export default function RatingStars({ rating = 0, count, size = 'w-3.5 h-3.5', showCount = true }) {
  return (
    <div className="flex items-center gap-1" data-testid="rating-stars">
      <div className="flex">
        {[1, 2, 3, 4, 5].map((i) => (
          <Star
            key={i}
            className={`${size} ${i <= Math.round(rating) ? 'fill-amber-400 text-amber-400' : 'text-zinc-300'}`}
            strokeWidth={1.5}
          />
        ))}
      </div>
      <span className="text-xs font-medium text-zinc-700">{rating > 0 ? rating.toFixed(1) : 'Baru'}</span>
      {showCount && count !== undefined && <span className="text-xs text-zinc-400">({count})</span>}
    </div>
  );
}
